var map = {
	"./BN01-cn-sulphate-aerosol.pdf": "e886",
	"./BN01-en-sulphate-aerosol.pdf": "4e97",
	"./BN02-cn-urban-flood.pdf": "80dc",
	"./BN02-en-urban-flood.pdf": "bae9",
	"./BN03-cn-food-security.pdf": "3d04",
	"./BN03-en-food-security.pdf": "0055",
	"./BN04-cn-communicating-uncertainity.pdf": "86b5",
	"./BN04-en-communicating-uncertainity.pdf": "77a6",
	"./BN05-cn-heatwave-cities.pdf": "4241",
	"./BN05-en-heatwave-cities.pdf": "bd77",
	"./E01-cn-investigating-heatwaves.pdf": "25f3",
	"./E01-en-investigating-heatwaves.pdf": "e280",
	"./E02-cn-increasing-flash-floods.pdf": "40cf",
	"./E02-en-increasing-flash-floods.pdf": "aa23",
	"./E03-cn-tibetan-plateau-vortices.pdf": "c95a",
	"./E03-en-tibetan-plateau-vortices.pdf": "dfa1",
	"./E04-cn-beijing-haze.pdf": "afde",
	"./E04-en-beijing-haze.pdf": "e795",
	"./E05-cn-satellite-instrument.pdf": "3baf",
	"./E05-en-satellite-instrument.pdf": "9f63",
	"./E06-cn-arup-climate-risk.pdf": "405f",
	"./E06-en-arup-climate-risk.pdf": "eb44",
	"./E07-cn-high-resolution.pdf": "486f",
	"./E07-en-high-resolution.pdf": "88a7",
	"./E08-cn-urban-rail-transport.pdf": "00e8",
	"./E08-en-urban-rail-transport.pdf": "0fb7",
	"./E09-cn-seasonal-forecast.pdf": "414b",
	"./E09-en-seasonal-forecast.pdf": "69fe",
	"./E10-cn-correcting-urban-bias.pdf": "1d35",
	"./E10-en-correcting-urban-bias.pdf": "6c70",
	"./E11-cn-flood-footprint-assessment.pdf": "ee7c",
	"./E11-en-flood-footprint-assessment.pdf": "bbde",
	"./E12-cn-working-together.pdf": "138c",
	"./E12-en-working-together.pdf": "87e2",
	"./E13-cn-examining-airflow.pdf": "32ee",
	"./E13-en-examining-airflow.pdf": "2ce4",
	"./E14-cn-increasing-summer-rainfall.pdf": "8996",
	"./E14-en-increasing-summer-rainfall.pdf": "0b8f",
	"./E15-cn-daily-satellite-monitoring.pdf": "5177",
	"./E15-en-daily-satellite-monitoring.pdf": "edea",
	"./E16-cn-flash-droughts.pdf": "9efb",
	"./E16-en-flash-droughts.pdf": "8fc3",
	"./E17-cn-extreme-cold.pdf": "0392",
	"./E17-en-extreme-cold.pdf": "25b3",
	"./E18-cn-extreme-rainfall.pdf": "02d5",
	"./E18-en-extreme-rainfall.pdf": "be95",
	"./I01-cn-food-security.pdf": "296d",
	"./I01-en-food-security.pdf": "bfd7",
	"./I02-cn-urban.pdf": "3397",
	"./I02-en-urban.pdf": "76eb",
	"./I03-cn-air-quality.pdf": "2d33",
	"./I03-en-air-quality.pdf": "2742",
	"./I04-en-seasonal-forecast.pdf": "657b",
	"./I05-en-assessing-risk.pdf": "5b01",
	"./handbook-cn-webversion-opt.pdf": "8a70",
	"./handbook-en-webversion-opt.pdf": "d32f",
	"./placeholder.pdf": "b2da",
	"./transcript-cn-training.pdf": "f081",
	"./transcript-en-podcast.pdf": "0905",
	"./transcript-en-training.pdf": "011b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c45";